import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=3b2e227c"
import script from "./AddStore.vue?vue&type=script&lang=js"
export * from "./AddStore.vue?vue&type=script&lang=js"
import style0 from "./AddStore.vue?vue&type=style&index=0&id=3b2e227c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports